/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type {
  Signer,
  BigNumberish,
  AddressLike,
  ContractDeployTransaction,
  ContractRunner,
} from "ethers";
import type { NonPayableOverrides } from "../common";
import type { Migration, MigrationInterface } from "../Migration";

const _abi = [
  {
    type: "constructor",
    inputs: [
      {
        name: "_hubV1",
        type: "address",
        internalType: "contract IHubV1",
      },
      {
        name: "_hubV2",
        type: "address",
        internalType: "contract IHubV2",
      },
      {
        name: "_inflationDayZero",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "convertFromV1ToDemurrage",
    inputs: [
      {
        name: "_amount",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "hubV1",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IHubV1",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "hubV2",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "address",
        internalType: "contract IHubV2",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "inflationDayZero",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "migrate",
    inputs: [
      {
        name: "_avatars",
        type: "address[]",
        internalType: "address[]",
      },
      {
        name: "_amounts",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    outputs: [
      {
        name: "",
        type: "uint256[]",
        internalType: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "period",
    inputs: [],
    outputs: [
      {
        name: "",
        type: "uint256",
        internalType: "uint256",
      },
    ],
    stateMutability: "view",
  },
  {
    type: "error",
    name: "CirclesAddressCannotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountMustNotBeZero",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAmountOverflow",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArrayMustNotBeEmpty",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesArraysLengthMismatch",
    inputs: [
      {
        name: "lengthArray1",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "lengthArray2",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesAvatarMustBeRegistered",
    inputs: [
      {
        name: "avatar",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesIdMustBeDerivedFromAddress",
    inputs: [
      {
        name: "providedId",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidCirclesId",
    inputs: [
      {
        name: "id",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidFunctionCaller",
    inputs: [
      {
        name: "caller",
        type: "address",
        internalType: "address",
      },
      {
        name: "expectedCaller",
        type: "address",
        internalType: "address",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidParameter",
    inputs: [
      {
        name: "parameter",
        type: "uint256",
        internalType: "uint256",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesInvalidString",
    inputs: [
      {
        name: "str",
        type: "string",
        internalType: "string",
      },
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesLogicAssertion",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
  {
    type: "error",
    name: "CirclesProxyAlreadyInitialized",
    inputs: [],
  },
  {
    type: "error",
    name: "CirclesReentrancyGuard",
    inputs: [
      {
        name: "code",
        type: "uint8",
        internalType: "uint8",
      },
    ],
  },
] as const;

const _bytecode =
  "0x60e060405234801561000f575f80fd5b50604051610ba1380380610ba183398101604081905261002e91610132565b6001600160a01b03831661005c576040516321efd2b360e01b81525f60048201526024015b60405180910390fd5b6001600160a01b038216610086576040516321efd2b360e01b815260016004820152602401610053565b6001600160a01b0383811660808190525f80546001600160a01b0319169285169290921790915560a08290526040805163ef78d4fd60e01b8152905163ef78d4fd916004808201926020929091908290030181865afa1580156100eb573d5f803e3d5ffd5b505050506040513d601f19601f8201168201806040525081019061010f9190610172565b60c05250610189915050565b6001600160a01b038116811461012f575f80fd5b50565b5f805f60608486031215610144575f80fd5b835161014f8161011b565b60208501519093506101608161011b565b80925050604084015190509250925092565b5f60208284031215610182575f80fd5b5051919050565b60805160a05160c0516109b86101e95f395f8181610127015281816101e10152818161037c01526103b901525f81816098015261020c01525f818160e00152818161014d0152818161026a01528181610300015261049d01526109b85ff3fe608060405234801561000f575f80fd5b5060043610610060575f3560e01c806379742f66146100645780637c234d01146100935780639a288377146100c8578063bde87738146100db578063de01e15114610102578063ef78d4fd14610122575b5f80fd5b5f54610076906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6100ba7f000000000000000000000000000000000000000000000000000000000000000081565b60405190815260200161008a565b6100ba6100d63660046106d9565b610149565b6100767f000000000000000000000000000000000000000000000000000000000000000081565b610115610110366004610738565b610413565b60405161008a91906107d9565b6100ba7f000000000000000000000000000000000000000000000000000000000000000081565b5f807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b031663a4caeb426040518163ffffffff1660e01b8152600401602060405180830381865afa1580156101a7573d5f803e3d5ffd5b505050506040513d601f19601f820116820180604052508101906101cb91906107f2565b90505f6101d982600161081d565b90505f6102067f000000000000000000000000000000000000000000000000000000000000000084610836565b610230907f000000000000000000000000000000000000000000000000000000000000000061081d565b90505f61023d824261084d565b604051631549c1a160e11b81526305f5e1006004820152602481018690529091505f906001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690632a93834290604401602060405180830381865afa1580156102af573d5f803e3d5ffd5b505050506040513d601f19601f820116820180604052508101906102d391906107f2565b604051631549c1a160e11b81526305f5e1006004820152602481018690529091505f906001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001690632a93834290604401602060405180830381865afa158015610345573d5f803e3d5ffd5b505050506040513d601f19601f8201168201806040525081019061036991906107f2565b90505f6103768483610836565b6103a0857f000000000000000000000000000000000000000000000000000000000000000061084d565b6103aa9085610836565b6103b4919061081d565b9050807f00000000000000000000000000000000000000000000000000000000000000006305f5e1006103e88c6003610836565b6103f29190610836565b6103fc9190610836565b6104069190610860565b9998505050505050505050565b606083821461044a57604051638b5ccddf60e01b815260048101859052602481018390525f60448201526064015b60405180910390fd5b5f8467ffffffffffffffff8111156104645761046461087f565b60405190808252806020026020018201604052801561048d578160200160208202803683370190505b5090505f5b8581101561066c575f7f00000000000000000000000000000000000000000000000000000000000000006001600160a01b03166328d249fe8989858181106104dc576104dc610893565b90506020020160208101906104f191906108be565b6040516001600160e01b031960e084901b1681526001600160a01b039091166004820152602401602060405180830381865afa158015610533573d5f803e3d5ffd5b505050506040513d601f19601f8201168201806040525081019061055791906108d9565b90506001600160a01b038116610583576040516321efd2b360e01b815260026004820152602401610441565b6105a486868481811061059857610598610893565b90506020020135610149565b8383815181106105b6576105b6610893565b602002602001018181525050806001600160a01b03166323b872dd33308989878181106105e5576105e5610893565b6040516001600160e01b031960e088901b1681526001600160a01b039586166004820152949093166024850152506020909102013560448201526064016020604051808303815f875af115801561063e573d5f803e3d5ffd5b505050506040513d601f19601f8201168201806040525081019061066291906108f4565b5050600101610492565b505f5460405163f317707960e01b81526001600160a01b039091169063f3177079906106a29033908a908a908790600401610913565b5f604051808303815f87803b1580156106b9575f80fd5b505af11580156106cb573d5f803e3d5ffd5b509298975050505050505050565b5f602082840312156106e9575f80fd5b5035919050565b5f8083601f840112610700575f80fd5b50813567ffffffffffffffff811115610717575f80fd5b6020830191508360208260051b8501011115610731575f80fd5b9250929050565b5f805f806040858703121561074b575f80fd5b843567ffffffffffffffff80821115610762575f80fd5b61076e888389016106f0565b90965094506020870135915080821115610786575f80fd5b50610793878288016106f0565b95989497509550505050565b5f815180845260208085019450602084015f5b838110156107ce578151875295820195908201906001016107b2565b509495945050505050565b602081525f6107eb602083018461079f565b9392505050565b5f60208284031215610802575f80fd5b5051919050565b634e487b7160e01b5f52601160045260245ffd5b8082018082111561083057610830610809565b92915050565b808202811582820484141761083057610830610809565b8181038181111561083057610830610809565b5f8261087a57634e487b7160e01b5f52601260045260245ffd5b500490565b634e487b7160e01b5f52604160045260245ffd5b634e487b7160e01b5f52603260045260245ffd5b6001600160a01b03811681146108bb575f80fd5b50565b5f602082840312156108ce575f80fd5b81356107eb816108a7565b5f602082840312156108e9575f80fd5b81516107eb816108a7565b5f60208284031215610904575f80fd5b815180151581146107eb575f80fd5b6001600160a01b038581168252606060208084018290529083018590525f91869160808501845b8881101561096157843561094d816108a7565b84168252938201939082019060010161093a565b508581036040870152610974818861079f565b9a995050505050505050505056fea264697066735822122020c2ba99b4debbe2a4abd5c016c29e74af13d0580bafa627bfe299b5fe8a437e64736f6c63430008180033";

type MigrationConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MigrationConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Migration__factory extends ContractFactory {
  constructor(...args: MigrationConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    _hubV1: AddressLike,
    _hubV2: AddressLike,
    _inflationDayZero: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(
      _hubV1,
      _hubV2,
      _inflationDayZero,
      overrides || {}
    );
  }
  override deploy(
    _hubV1: AddressLike,
    _hubV2: AddressLike,
    _inflationDayZero: BigNumberish,
    overrides?: NonPayableOverrides & { from?: string }
  ) {
    return super.deploy(
      _hubV1,
      _hubV2,
      _inflationDayZero,
      overrides || {}
    ) as Promise<
      Migration & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): Migration__factory {
    return super.connect(runner) as Migration__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MigrationInterface {
    return new Interface(_abi) as MigrationInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): Migration {
    return new Contract(address, _abi, runner) as unknown as Migration;
  }
}
